/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

export const TwentyIcArrowRight = ({
  className,
  color = "black",
  onClick = () => {},
}) => {
  return (
    <svg
      className={`twenty-ic-arrow-right ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        className="path"
        d="M9 5C9 7.5 13 10 13 10C13 10 9 12.5 9 15"
        stroke={color}
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
